import React, { ReactNode } from "react";
import classnames from "classnames";
import "./Container.less";

export type ContainerSize = "small" | "medium" | "large";

export interface ContainerProps {
    size?: ContainerSize;
    noMargin?: boolean;
    noPadding?: boolean;
    noPaddingTop?: boolean;
    extraPaddingTop?: boolean;
    extraMarginBottom?: boolean;
    whiteBg?: boolean;
    overlappingFullWidthImage?: boolean;
    children?: ReactNode;
}

const Container: React.FC<ContainerProps & React.HTMLAttributes<HTMLDivElement>> = ({
    children,
    className,
    size,
    noMargin,
    noPadding,
    noPaddingTop,
    extraPaddingTop,
    extraMarginBottom,
    whiteBg,
    overlappingFullWidthImage,
    ...rest
}) => (
    <div
        className={classnames("container", className, {
            [`container--${size}`]: size,
            "container--no-margin": noMargin,
            "container--no-padding": noPadding,
            "container--no-padding-top": noPaddingTop,
            "container--extra-padding-top": extraPaddingTop,
            "container--extra-margin-bottom": extraMarginBottom,
            "container--white-bg": whiteBg,
            "container--overlapping-full-width-image": overlappingFullWidthImage,
        })}
        {...rest}
    >
        {children}
    </div>
);

export default Container;
